import { REMOVE_USERS, SET_FILTER_USER_DATA, SET_TOTAL_FILTERED_USERS, SET_USER_DATA, SET_USER_PERCENTAGE, SET_USERS_COUNT } from "../types";

export const setUserData = (data) => ({
    type: SET_USER_DATA,
    payload: data,
})

export const setUserPercentage = (data) => ({
    type: SET_USER_PERCENTAGE,
    payload: data,
})

export const setUserCount = (count) => ({
    type: SET_USERS_COUNT,
    payload: count,
})

export const setFilterUserData = (data) => ({
    type: SET_FILTER_USER_DATA,
    payload: data,
})

export const removeUers = () => {
    return {
        type: REMOVE_USERS
    }
}

export const setTotalFilteredUsers = (totalFilteredUsers) => ({
    type: SET_TOTAL_FILTERED_USERS,
    payload: totalFilteredUsers,
});
